import { create } from 'zustand'
import update from 'immutability-helper'

type FormValues = Record<string, any>

type Form = {
  id: string
  values: FormValues
}

interface FormState {
  forms: Form[]
  updateFormValues: (id: string, values: FormValues) => void
  resetForm: (id: string) => void
}

const useFormStore = create<FormState>(set => ({
  forms: [],
  updateFormValues: (id, values) =>
    set(state => {
      const index = state.forms.findIndex(form => form.id === id)
      if (index === -1) {
        return {
          forms: update(state.forms, {
            $push: [{ id, values }],
          }),
        }
      }
      return {
        forms: update(state.forms, {
          [index]: {
            $set: { id, values },
          },
        }),
      }
    }),
  resetForm: id =>
    set(state => ({ forms: state.forms.filter(form => form.id !== id) })),
}))

export default useFormStore
